import Sentry from 'Integrations/Sentry';
import moment from 'moment';

class Account {}

const type = 'account';

export default Account;

export const fromAPIResponse = (res) => {
  if (res.type !== type) {
    throw new Error(`expected type ${type}, got ${res.type}`);
  }
  return Object.assign(new Account(), res.attributes, {
    id: res.id,
    lastSync: moment(res.attributes.lastSync),
  });
};

// sumBalance sums the balance of all accounts
export const sumBalance = accounts => accounts
  .map((acct) => {
    const balance = Number.parseFloat(acct.balance);
    if (Number.isNaN(balance)) {
      Sentry.createSentryErrorLog(
        new Error(`account ${acct.id} has a balance that is NaN: ${balance}`),
      );
    }
    return balance;
  })
  .filter(balance => !Number.isNaN(balance))
  .reduce((a, b) => a + b, 0);

// percentEquity determines the percentage points of equity that this account
// is invested in.  The facetModel field is inspected for an equity value, and
// should take the form of X-Y-Z where Z will either be [0-9]+ or 'Cash'.
// If an unexpected value is found for the equity value, null is returned.
export const percentEquity = (account) => {
  const { facetModel } = account;
  if (!facetModel) {
    return 0;
  }
  const parts = facetModel.split('-');
  if (parts.length === 0) {
    return null;
  }
  const equityString = parts[parts.length - 1];
  if (
    equityString.toLowerCase() === 'cash'
    || equityString.toLowerCase() === 'default'
  ) {
    return 0;
  }
  if (!equityString.match(/[0-9]+/g)) {
    return null;
  }
  return Number.parseInt(equityString, 10);
};
